import { DraftRunStage } from "../../../store/queries/contractModelDrafts";

/**
 * CLE-2811 — the suggested prompts above the conversation's composer. Static and stage-aware: the questions
 * worth asking about a contract's FACTS are not the ones worth asking once rates are modeled. Clicking one
 * puts its text in the composer for her to edit or send; it never sends on its own.
 */

/** The facts stage: what the contract says, before anything is priced. */
export const FACTS_STAGE_PROMPTS: readonly string[] = [
  "List every CPT code and rate, one per line, per plan",
  "What is the timely filing limit?",
  "Which plans have escalators, and when?",
  "How are implants paid?",
  "Summarize how each plan pays in one sentence",
];

/** The rates stage (`full`): how the modeled rates were read. */
export const RATES_STAGE_PROMPTS: readonly string[] = [
  "Which service lines are priced as a percent of Medicare?",
  "List the carve-out codes and rates per plan",
  "What conditions apply to the carve-out rates?",
];

/** The chips for a run's stage. */
export const suggestedPrompts = (stage: DraftRunStage): readonly string[] =>
  stage === "facts" ? FACTS_STAGE_PROMPTS : RATES_STAGE_PROMPTS;

/** The chips to show right now: none while she is typing (the composer holds anything but whitespace). */
export const promptsToShow = (
  stage: DraftRunStage,
  draft: string
): readonly string[] => (draft.trim() === "" ? suggestedPrompts(stage) : []);
